import React, { useState, memo } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";
import PropTypes from "prop-types";

// Components
import DeleteModal from "./components/delete-modal";
import EditUserModal from "./components/edit-user-modal";
import { useBoolean } from "../../../../hooks/use-boolean";
import { useDeleteteamsMutation } from "../../../../store/Reducer/teams";
import toast from "react-hot-toast";

// Table Row Component
const TableRow = memo(({ data, onEditRow, onDelete }) => (
  <tr className="hover:bg-gray-50">
    <td className="px-4 py-3 font-medium text-gray-900">{data?.name}</td>
    <td className="px-4 py-3 text-gray-600 break-all">{data?.email}</td>
    <td className="px-4 py-3 text-gray-600">{Number(data?.permission) >= 3 ? "Team member" : "Owner"}</td>
    <td className="px-4 py-3">
      {data?.isActive === false ? <StatusPill tone="gray">Inactive</StatusPill> : <StatusPill tone="green">Active</StatusPill>}
    </td>
    <td className="px-4 py-3">
      <RowActions onEdit={() => onEditRow(data)} onDelete={() => onDelete(data._id)} editLabel={`Edit ${data?.name || "member"}`} deleteLabel={`Delete ${data?.name || "member"}`} />
    </td>
  </tr>
));

TableRow.propTypes = {
  data: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default function TableBodyCustom({ data,onEditRow }) {
  const [selectedId, setSelectedId] = useState(null);
  const [selectedEditRowdata, setSelectedEditRowData] = useState(null);
 const [deleteteams] = useDeleteteamsMutation(); // Hook to call deleteNews API
  const quickEdit = useBoolean();
  const confirm = useBoolean();

  const handleEditModalOpen = (rowData) => {
    setSelectedEditRowData(rowData);
    quickEdit.onTrue();
  };

  const handleEditModalClose = () => {
    quickEdit.onFalse();
  };

  const handleDeleteModalOpen = (id) => {
    setSelectedId(id);
    confirm.onTrue();
  };

  const handleDeleteModalClose = () => {
    confirm.onFalse();
  };

  // console.log('selectedid',selectedId)

 
  const handleDelete = async () => {
 

    if (selectedId) {
      try {
      
        await deleteteams(selectedId).unwrap(); 
        handleDeleteModalClose(); 
      } catch (error) {
        toast.error(error?.data?.message || "An error occurred");

      }
    }
  };

  return (
    <>
      <TableRow
        data={data}
        onEdit={handleEditModalOpen}
        onDelete={handleDeleteModalOpen}
        onEditRow={onEditRow}
      />

      <DeleteModal
        isOpen={confirm.value}
        title="Are You Sure?"
        desc="This record will be permanently deleted. This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={handleDeleteModalClose}
      />

      <EditUserModal
        isOpen={quickEdit.value}
        closeModal={handleEditModalClose}
        selectedEditRowdata={selectedEditRowdata}
      />
    </>
  );
}
